export default "__VITE_ASSET__43ef11bd__"